// Form definitions in SurveyJS format (see https://surveyjs.io/)
import {SHORT_REG} from "./short-reg.js";
import {FULL_REQUEST} from "./full-request.js";
import {FULL_MULTIPAGE} from "./full-multipage.js";
import {FULL_MULTIPAGE_SIMPLIFIED} from "./full-multipage-simplified.js";

export const defs = {SHORT_REG, FULL_REQUEST, FULL_MULTIPAGE, FULL_MULTIPAGE_SIMPLIFIED};

export default defs;
